module.exports = __webpack_public_path__ + "assets/img/ko-c12e8871.png";